
export function trim_name(name, numWords) {
      var split = name.split(/\s+/, numWords);
      var trimmedName = split.join(" ");
      return trimmedName;
  }
